// 全体の親
import Contract from "@/pages/contract/Index";

// 契約内容確認
import ContractDetails from '@/pages/contract/ContractDetails';
// 契約内容変更
import ContractChanges from "@/pages/contract/ContractChanges";
// 契約内容変更確認
import ConfirmChanges from "@/pages/contract/ConfirmChanges";

// システムエラー
import SystemError from "@/pages/SystemError";

export default {
    path: "/service",
    component: Contract,
    children: [
        // 契約内容確認
        {
            path: "details",
            name: "ContractDetails",
            component: ContractDetails,
            props: true
        },
        // 契約内容変更
        {
            path: "changes",
            name: "ContractChanges",
            component: ContractChanges,
            props: true,
        },
        // 契約内容変更確認
        {
            path: "confirm",
            name: "ConfirmChanges",
            component: ConfirmChanges,
            props: true,
        },
        // システムエラー
        {
            path: "system_error",
            name: "ServiceSystemError",
            component: SystemError,
            props: true,
        }
    ]
}
